/**
 * ToggleLanguage Stateless Component
 */
import { LanguageModalComponent } from "components/UI/Toggle/LanguageModal";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  IHelpersActionCreator,
  setShowLanguageModal,
} from "root/store/helpers/ActionCreators";
import { IHelpersState } from "root/store/helpers/Reducer";

type IToggleLanguageProps = LocalizeContextProps & IToggleLanguageFunc;

interface IToggleLanguageFunc {
  showModal: (show: boolean) => void;
}

/**
 * ToggleLanguage Stateless Component
 */
class Toggle extends React.Component<IToggleLanguageProps> {
  constructor(props: IToggleLanguageProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <div className="toggle-language">
        <div id="language-modal">
          <LanguageModalComponent />
        </div>
        <button
          type="button"
          id="language-button"
          className="change-language"
          onClick={(): void => {
            this.props.showModal(true);
          }}
        >
          <Translate id="footer.changeLanguage" />
        </button>
      </div>
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<IHelpersState, undefined, IHelpersActionCreator>
): object => ({
  showModal: (show: boolean): IHelpersActionCreator =>
    dispatch(setShowLanguageModal(show)),
});

const ToggleLanguage: React.ComponentClass = connect(
  undefined,
  mapDispatchToProps
)(withLocalize<IToggleLanguageProps>(Toggle));

export { ToggleLanguage };



// WEBPACK FOOTER //
// ./src/components/UI/Toggle/ToggleLanguage.tsx